<section class="page">
  <div class="page-header">
    <h1>Termin auswählen</h1>
    <p>Wählen Sie einen passenden Termin aus den verfügbaren Zeiten.</p>
  </div>

  <app-error-banner [message]="errorMessage"></app-error-banner>

  <div class="loading-state" *ngIf="isLoading">
    <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
    <span>Termine werden geladen…</span>
  </div>

  <div class="calendar-layout" *ngIf="!isLoading">
    <mat-card class="calendar-pane">
      <mat-calendar
        [selected]="selectedDate"
        (selectedChange)="onDateSelected($event)"
        [dateClass]="dateClass"
      ></mat-calendar>
    </mat-card>

    <mat-card class="slots-pane">
      <div class="slots-header">
        <h3>Uhrzeiten</h3>
        <span class="selected-date">{{ selectedDay?.displayDate || '—' }}</span>
      </div>

      <div class="slots-list" *ngIf="selectedDay?.slots?.length; else emptyState">
        <button
          mat-stroked-button
          class="slot-button"
          *ngFor="let slot of selectedDay?.slots"
          [class.selected]="selectedSlot?.id === slot.id"
          (click)="selectSlot(slot)"
        >
          {{ slot.displayTime }}
        </button>
      </div>

      <ng-template #emptyState>
        <div class="empty-state">
          <p>Für diesen Tag sind keine Termine verfügbar.</p>
        </div>
      </ng-template>
    </mat-card>
  </div>

  <div class="action-bar" *ngIf="!isLoading">
    <button mat-stroked-button color="primary" (click)="back()">Zurück</button>
    <button mat-flat-button color="primary" [disabled]="!hasSlotSelection" (click)="continue()">
      Weiter
    </button>
  </div>
</section>
